import * as React from "react"

import { Row, Col, Alert } from "shards-react"
import SidesheetApplyForm from "../components/applyForm"

import { routify } from "../js/routify"

// View Components
import MobileView from "../common/mobileView"
import BrowserView from "../common/browserView"

class CsecMenuTray extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      routes: require("../data/routes.json")
    }
  }

  render() {
    return (
      <>
        <>
          <Row className="text-center pt-2 pb-1">
            <Col xs={6}>
              <a href={routify(this.props.countryCode, this.state.routes.cape)}>
                <Alert theme="danger">For CAPE</Alert>
              </a>
            </Col>
            <Col xs={6}>
              <a
                href={routify(
                  this.props.countryCode,
                  this.state.routes.examFaqs
                )}
              >
                <Alert theme="success">Exam FAQs</Alert>
              </a>
            </Col>
            <Col xs={12}>
              <BrowserView>
                <SidesheetApplyForm />
              </BrowserView>

              <MobileView>
                <a
                  href={routify(
                    this.props.countryCode,
                    this.state.routes.apply
                  )}
                >
                  <Alert theme="primary">Enroll Now</Alert>
                </a>
              </MobileView>

              <p>
                <a
                  href={routify(this.props.countryCode, this.state.routes.chat)}
                  className="text-center text-primary pb-2"
                >
                  Speak with an Enrollment Officer
                </a>
              </p>
            </Col>
          </Row>
        </>
      </>
    )
  }
}

export default CsecMenuTray
